// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculateColor.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * DataType component
 */
import React from 'react';
import { observer } from 'mobx-react';
import FormGroup from 'share/components/controls/Izenda.FormGroup';
import Label from 'share/components/controls/Izenda.Label';
import ColorStyling from 'share/components/controls/Izenda.ColorStyling';
import constants from 'logic/data/Izenda.CalculatedFieldConstants';

@observer
class Color extends React.Component {
  static displayName = 'Color';

  constructor(props) {
    super(props);
    let {
      store: { clonedModel: model }
    } = this.props;

    let valueFontColor = {
      backgroundColor: constants.DEFAULT_VALUE_PROPERTIES.FONT.BACKGROUND_COLOR,
      color: constants.DEFAULT_VALUE_PROPERTIES.FONT.COLOR
    };

    // Change default values if already updated
    if(model.font && model.font.backgroundColor) valueFontColor.backgroundColor = model.font.backgroundColor;
    if(model.font && model.font.color) valueFontColor.color = model.font.color;

    this.state = {
      backgroundColor: valueFontColor.backgroundColor,
      color: valueFontColor.color,
      // alignment: constant.DEFAULT_VALUE.ALIGNMENT
      valueFontColor: valueFontColor
    };

  }

  onChangeFontColor = (e) => {
    let value = e.value || {};
    this.setState({
      color: value.textColor,
      backgroundColor: value.backgroundColor
    });

    this.props.store.clonedModel.changeFontColor({
      color: value.textColor,
      backgroundColor: value.backgroundColor
    });
  }

  render() {
    let {
      localization,
      type: { name: typeName }
    } = this.props;

    if (typeName !== constants.TYPES.SUB_TOTAL.name && typeName !== constants.TYPES.GRAND_TOTAL.name) {
      return null;
    }

    let state = this.state;
    let valueFontColor = {
      textColor: state.color,
      backgroundColor: state.backgroundColor
    };

    return (
      <FormGroup className="u_paddingRight">
        <Label className="col-md-3 text-left u_paddingLeft">
            {localization.getText('COMMON_LABEL_COLOR')}
        </Label>
        <div className="col-md-9 u_noPaddingAll grand-total-section">
          <ColorStyling value={valueFontColor} onChange={this.onChangeFontColor} />
        </div>
      </FormGroup>
    );
  }
}

export default Color;



// WEBPACK FOOTER //
// ./ui/share/components/controls/calculatedField/Izenda.CalculateColor.js